import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="mt-auto pt-12">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pb-16">
        <div className="marketing-panel px-6 py-10 sm:px-10 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <span className="font-serif text-3xl text-ink" style={{ fontWeight: 600 }}>
              Photo<span className="text-rose">Feeler</span>
            </span>
            <p className="text-sm text-ink-muted mt-4 leading-relaxed max-w-[240px]">
              Premium photo and profile coaching for the two first impressions that matter most: dating apps and LinkedIn.
            </p>
          </div>
          <div>
            <h4 className="text-xs font-sans font-medium text-ink-muted tracking-wider uppercase mb-4">Product</h4>
            <ul className="space-y-2.5">
              <li><a href="/#see-result" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Sample Result</a></li>
              <li><Link to="/purchase" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Pricing</Link></li>
              <li><Link to="/blog" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Blog</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-sans font-medium text-ink-muted tracking-wider uppercase mb-4">Use Cases</h4>
            <ul className="space-y-2.5">
              <li><Link to="/dating" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Dating Profiles</Link></li>
              <li><Link to="/linkedin" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">LinkedIn Profiles</Link></li>
              <li><Link to="/?auth=1" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Photo Compare</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-sans font-medium text-ink-muted tracking-wider uppercase mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li><Link to="/privacy" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Privacy</Link></li>
              <li><Link to="/terms" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Terms</Link></li>
              <li><a href="mailto:hello@photofeeler.ai" className="text-sm text-ink-faint hover:text-rose transition-colors duration-300">Contact</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-surface-border mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[11px] text-ink-faint">
            &copy; {new Date().getFullYear()} PhotoFeeler AI
          </p>
          <p className="text-[11px] text-ink-faint">
            Private by default. Photos are auto-deleted after 30 days.
          </p>
        </div>
        </div>
      </div>
    </footer>
  );
}
